import { useAPIAction, ImagesDraftApi } from "melco-shared-logic";

export const useDuplicateBlankPicture = (blankPictureId: string) => {
  return useAPIAction(
    ImagesDraftApi,
    async (api) => {
      const data = await api.userImageDuplicateDraft({
        id: blankPictureId,
      });

      return {
        successMessages: [{ message: "default" }],
        data,
      };
    },
    { translationPrefix: "blank_pictures.actions.duplicate" }
  );
};
